import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";

import Select, { components } from "react-select";
// https://react-select.com/styles
export default ({
  isDisabled = false,
  hideselectionOptions = true,
  isLoading = false,
  isClearable = false,
  isRtl = false,
  isSearchable = false,
  name = "custom name",
  value,
  onChange,
  className,
  options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
  ],
  defaultValue = null,
}) => {
  // this controls the value to display
  const initialState = defaultValue || options[0];
  const [selectedState, setSelectedState] = useState(initialState);

  useEffect(() => {
    // name === "exchanges_agencies" && setSelectedState(options[0])
    if (name === "exchanges_agencies") return;

    if (name === "flags") return;
    //setSelectedState(options[0])

    setSelectedState(options.find((item) => item.value === value));
  }, [value, name, options]);

  const selectchange = (data) => {
    try {
      onChange(data);
    } finally {
      setSelectedState(data);
    }
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {name === "country_foreign_exchange" ? (
          <StaticImage
            alt="icono de drop"
            src="../../images/gray_dropdown_indicator.webp"
            width={25}
            height={24}
          />
        ) : (
          <StaticImage
            alt="icono de drop"
            src="../../images/white_dropdown_indicator.webp"
            width={9}
            height={6}
          />
        )}
      </components.DropdownIndicator>
    );
  };
  //-------------------------------------------

  return (
    <Select
      className={className}
      unstyled
      styles={{
        dropdownIndicator: (base, state) => ({
          ...base,
          transition: "all .2s ease",
          transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
        }),
      }}
      components={{ DropdownIndicator }}
      classNamePrefix="select"
      onChange={selectchange}
      value={
        typeof selectedState !== "undefined" ? selectedState : initialState
      }
      // value={name === "country_foreign_exchange" ? value : selectedState}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isClearable={isClearable}
      isRtl={isRtl}
      isSearchable={isSearchable}
      name={name}
      options={options}
      placeholder=""
      hideSelectedOptions={hideselectionOptions}
    />
  );
};
